// extracted by mini-css-extract-plugin
export default {"media":"SocialMedia_media__IuXzK","button":"SocialMedia_button__DS4vO"};